import { useLiquidGlassPress } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { hapticFeedback } from '@tma.js/sdk';
import { type FC } from 'react';
import { SubTaskType } from '../../client/generated/graphql';
import { CommonIcon } from '../common/CommonIcon';

const ROW_DIVIDER_BORDER = '1px solid color-mix(in srgb, var(--tg-theme-text-color) 16%, transparent)';

interface RitualTaskItemProps {
    name: string;
    taskType?: SubTaskType | null;
    showDivider?: boolean;
    onClick: () => void;
}

const getTaskIcon = (taskType?: SubTaskType | null): string => {
    switch (taskType) {
        case SubTaskType.Journal:
            return 'description';
        case SubTaskType.Rating:
            return 'star_outline';
        default:
            return 'check_box';
    }
};

export const RitualTaskItem: FC<RitualTaskItemProps> = ({ name, taskType, showDivider = false, onClick }) => {
    const { pressed, onPointerDown, onPointerMove, onPointerUp, onPointerCancel, onClick: handleClick } = useLiquidGlassPress({
        preventDefault: true,
        onActivate: () => {
            hapticFeedback.impactOccurred.ifAvailable('light');
            onClick();
        },
    });

    return (
        <Box
            component="button"
            type="button"
            aria-label={name}
            onClick={handleClick}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onPointerCancel={onPointerCancel}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                m: 0,
                p: '12px 16px',
                border: 'none',
                borderTop: showDivider ? ROW_DIVIDER_BORDER : 'none',
                background: 'none',
                textAlign: 'left',
                cursor: 'pointer',
                font: 'inherit',
                color: 'inherit',
                WebkitTapHighlightColor: 'transparent',
                outline: 'none',
                bgcolor: pressed ? 'color-mix(in srgb, var(--tg-theme-text-color) 6%, transparent)' : 'transparent',
                transition: 'background-color 0.12s ease',
            }}
        >
            <Text style={{ fontSize: '15px', fontWeight: 500, color: 'var(--tg-theme-text-color)' }}>{name}</Text>
            <Stack direction="row" alignItems="center" gap={1}>
                <CommonIcon icon={getTaskIcon(taskType)} type="outlined" size={22} color="var(--tgui--hint_color)" />
                <CommonIcon icon="chevron_right" type="filled" size={20} color="var(--tgui--hint_color)" />
            </Stack>
        </Box>
    );
};
